<template>
  <div class="form_container">
    <form @submit.prevent="submitForm">
      <div class="auth-form-container mt-2">
        <h2>Send email</h2>
        <div class="block-input">
          <InputCustom
            v-model.trim="email"
            :type="'text'"
            :className="{
              error: email && !isEmailValid,
              required: isEmailValid === false,
              valid: isEmailValid,
            }"
            :placeholder="'Enter your email'"
          />
        </div>
        <div class="col-12 py-2">
          <ButtonWithLoading
            title="Send"
            :isLoading="isLoading"
            type="submit"
            class="w-100"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { DataService } from "../../../config/dataService";
import store from "../../../vuex/store";
import ButtonWithLoading from "../ButtonWithLoading.vue";
import InputCustom from "../InputCustom.vue";

export default {
  name: "SendEmailForRestorePassword",
  components: {
    ButtonWithLoading,
    InputCustom,
  },
  data() {
    return {
      email: "",
      isEmailValid: false,
    };
  },
  computed: {
    isLoading() {
      return store?.getters.isLoading;
    },
  },
  methods: {
    closeModal() {
      this.$emit("cancel");
    },
    validateEmail() {
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.isEmailValid = emailRegex.test(this.email);
    },

    async submitForm() {
      if (this.isEmailValid) {
        try {
          store.dispatch("startLoading");
          await DataService.post("users/send-email-restore-password", {
            email: this.email.toLowerCase(),
          });
          this.closeModal();
          this.$notifications.notify({
            message: `<span>Check your email</span>`,
            icon: "nc-icon nc-check-2",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        } catch (error) {
          this.$notifications.notify({
            message: `<span>${error.response.data.errorDescription}</span>`,
            icon: "nc-icon nc-simple-remove",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } finally {
          store.dispatch("endLoading");
        }
      }
    },
  },
  watch: {
    email() {
      this.validateEmail();
    },
  },
};
</script>

<style scoped lang="scss"></style>
